import React from 'react';
import './Services.css';
import ServiceCard from '../../cards/service-card/service-card';
import { Service } from '../../../api/servicesApi';

interface ServicesProps {
    services: Service[];
    loading: boolean;
}

const Services: React.FC<ServicesProps> = ({ services, loading }) => {
    return (
        <section id="services" className="services">
            <div className="container">
                <h2>Our Services</h2>
                {loading ? (
                    <div className="loading">
                        <div className="spinner"></div>
                        <p>Loading services...</p>
                    </div>
                ) : (
                    <div className="services-grid">
                        {services.map((service) => (
                            <ServiceCard
                                key={service.id}
                                className="service-card-wrapper"
                                title={service.title}
                                description={service.description}
                                iconType={service.iconType}
                                iconValue={service.iconValue}
                            />
                        ))}
                    </div>
                )}
            </div>
        </section>
    );
};

export default Services;
